import React from "react";
import { LinkToNewTabKeepContext } from "common";
import { SubmittedRequestType, SubmittedStatus } from "./SubmittedRequestDomain";
import { SubmittedRequestColumn } from "./SubmittedRequestDomain";
import {useApplicationRootUrl} from "../../../common/component/ApplicationRootContext";
import {formatDateStr} from "../../../common/util/date";

type SubmittedRequestPreviewProps = {
    request: {
        guid: string;
        caseNumber: string;
        clientName: string;
        clientGuid?: string | null;
        requestType: string;
        submittedDate: string;
        submitterName: string;
        status: string;
        closedDate: string | null;
        [key: string]: any;
    };
    isSelected: boolean;
    onClick: () => void;
    columns: Readonly<SubmittedRequestColumn[]>;
}

export function SubmittedRequestPreview({ request, isSelected, onClick, columns }: SubmittedRequestPreviewProps) {
    const rootUrl = useApplicationRootUrl();
    const formatDate = (dateString: string | null) => {
        if (!dateString) return '-';
        return formatDateStr(dateString);
    };

    const getFieldValue = (attr: string) => {
        switch (attr) {
            case 'submittedDate':
            case 'closedDate':
                return formatDate(request[attr]);
            case 'requestType':
                const enumKey = request[attr] as keyof typeof SubmittedRequestType;
                return SubmittedRequestType[enumKey] || request[attr];
            case 'status':
                const statusKey = request[attr] as keyof typeof SubmittedStatus;
                return SubmittedStatus[statusKey] || request[attr];
            default:
                return request[attr] || '-';
        }
    };

    return (
        <tr
            className={`border-b border-gray-200 relative hover:bg-gray-200 
                ${isSelected ? 'bg-blue-50' : ''}
            `}
            onClick={onClick}
        >
            {columns.map((column, index) => (
                <td
                    key={column.attr}
                    className={'py-5' + (index === 0 ? ' pl-8' : '')}
                >
                    {column.attr === 'clientName' ? (
                        request.clientGuid ? (
                            <LinkToNewTabKeepContext link={`${rootUrl}/clients/${request.clientGuid}/authorizations`}>
                                <span className={`underline ${isSelected ? 'text-white' : 'text-blue-portal-link'}`}>
                                    {getFieldValue(column.attr)}
                                </span>
                            </LinkToNewTabKeepContext>
                        ) : (
                            <span className={`cursor-default  text-gray-500 }`} aria-disabled="true">n/a</span>
                        )
                    ) : column.attr === 'caseNumber' ? (
                        <span className="font-medium">
                            {getFieldValue(column.attr)}
                        </span>
                    ) : (
                        <span className={column.attr === 'status' ? `status-${request.status.toLowerCase().replace(/\s+/g, '-')}` : ''}>
                            {getFieldValue(column.attr)}
                        </span>
                    )}
                </td>
            ))}
        </tr>
    );
}
